import { setTags } from '@sentry/react';
import { useEffect } from 'react';

export const useSentryTags = (tags: Parameters<typeof setTags>[0]) => {
  useEffect(() => {
    setTags(tags);
    return () => setTags(Object.fromEntries(Object.entries(tags).map(([key]) => [key, undefined])));
  }, [tags]);
};
